/**
 * Opening hours for Prozenthaus.
 * Monday=1 ... Sunday=7 (ISO weekday).
 * null means closed all day.
 */
export const OPENING_HOURS = {
  1: { open: "09:00", close: "16:00", label: "09:00 – 16:00 Uhr" }, // Mo
  2: { open: "09:00", close: "16:00", label: "09:00 – 16:00 Uhr" }, // Di
  3: null,                                                          // Mi
  4: { open: "09:00", close: "16:00", label: "09:00 – 16:00 Uhr" }, // Do
  5: { open: "09:00", close: "16:00", label: "09:00 – 16:00 Uhr" }, // Fr
  6: null,                                                          // Sa
  7: null,                                                          // So
};

export const OPENING_HOURS_DISPLAY = [
  { range: "Montag – Dienstag", hours: "09:00 – 16:00 Uhr", days: [1, 2] },
  { range: "Mittwoch",          hours: "Geschlossen",       days: [3] },
  { range: "Donnerstag – Freitag", hours: "09:00 – 16:00 Uhr", days: [4, 5] },
  { range: "Samstag – Sonntag", hours: "Geschlossen",       days: [6, 7] },
];

/** Returns { open: boolean, label: string } for current local time. */
export function getOpenStatus(now = new Date()) {
  // Map JS getDay() (Sun=0..Sat=6) to ISO weekday (Mon=1..Sun=7)
  const js = now.getDay();
  const iso = js === 0 ? 7 : js;
  const today = OPENING_HOURS[iso];

  const hh = String(now.getHours()).padStart(2, "0");
  const mm = String(now.getMinutes()).padStart(2, "0");
  const cur = `${hh}:${mm}`;

  if (today && cur >= today.open && cur < today.close) {
    return { open: true, label: `Jetzt geöffnet – bis ${today.close} Uhr` };
  }
  return { open: false, label: "Aktuell geschlossen" };
}
